import React from "react";
import Helmet from "react-helmet";
import codeExample from "./hitdelayfixmod-code-example.png";
import codeExample2 from "./hitdelayfixmod-code-example2.png";
import { connect } from "react-redux";
import { authActions } from "../../../core/auth";
import Main from "../../components/main";
import Box from "../../components/box";
import H1 from "../../components/h1";
import H2 from "../../components/h2";
import H3 from "../../components/h3";
import P from "../../components/p";
import Button from "../../components/button";
import A from "../../components/a";
import "./style.css";

class HitDelayFixMod extends React.PureComponent {
  // componentDidMount() {
  //   const desktop = document.getElementById("twitter-quote-trustbox-desktop");
  //   const loadFromElement = () => {
  //     if (window.Trustpilot) {
  //       window.Trustpilot.loadFromElement(desktop);
  //     } else {
  //       setTimeout(loadFromElement, 500);
  //     }
  //   };
  //   loadFromElement();
  // }

  // shouldComponentUpdate() {
  //   return false;
  // }

  render() {
    return (
      <div>
        {/* <SaleBanner
          loggedIn={this.props.loggedIn}
          premium={this.props.premium}
          signInWithGoogle={this.props.signInWithGoogle}
          fromClickTest={true}
        /> */}
        <Main isBlog>
          <Helmet>
            <title>
              HitDelayFixMod: Fix the hit delay in Minecraft 1.8 PvP
            </title>
            <meta
              name="description"
              content="A forge mod for minecraft 1.8 that sets leftClickCounter to 0
              after a miss, therefore fixing the hit delay problem in 1.8."
            />
          </Helmet>
          <Box isBlog>
            <H1 isBlog>
              HitDelayFixMod: Fix the hit delay in Minecraft 1.8 PvP
            </H1>
            <div
              style={{ display: "flex", marginBottom: 32 }}
              className="links"
            >
              <div style={{ marginRight: 48 }}>
                <div style={{ marginBottom: 8 }}>
                  <A href="https://github.com/ghast/HitDelayFixMod/releases/download/1.0.0/HitDelayFix.jar">
                    Download HitDelayFixMod
                  </A>
                </div>
                <div>
                  <A
                    href="https://github.com/ghast/HitDelayFixMod"
                    target="_blank"
                  >
                    View source code
                  </A>
                </div>
              </div>
              <div>
                <div style={{ marginBottom: 8 }}>
                  <A href="https://github.com/ghast/HitDelayFixMod/releases/download/1.0.0-debug/HitDelayFixDebug.jar">
                    Download Debug Version
                  </A>
                </div>
                <div>
                  <A
                    href="https://github.com/ghast/HitDelayFixMod/tree/debug"
                    target="_blank"
                  >
                    View debug source code
                  </A>
                </div>
              </div>
            </div>

            <div style={{ marginBottom: 16 }}>
              <img
                src="https://img.shields.io/github/downloads/ghast/HitDelayFixMod/total"
                alt="Download counter"
                style={{ marginRight: 16 }}
              />
              <img
                src="https://img.shields.io/badge/minecraft%20forge-1.8-blue"
                alt="Minecraft forge 1.8"
              />
            </div>

            <P isBlog>
              A forge mod for minecraft 1.8 that sets leftClickCounter to 0
              after a miss, therefore fixing the hit delay problem in 1.8.
            </P>

            <H2 isBlog>Installation</H2>
            <P isBlog>
              Simply place the jar file in your forge mods folder as you would
              with any other forge mod. Delete the jar file to uninstall the
              mod.
            </P>
            <P isBlog>
              Note: HitDelayFix will NOT appear in your forge mods list.
            </P>

            <H2 isBlog>About HitDelayFix</H2>
            <P isBlog>
              If you are a Minecraft PvPer, you are probably using an outdated
              version of Minecraft. On versions 1.8+ there is a delay which is
              triggered every time you click without attacking a player/mob. To
              be clear, when you click your mouse if you are not looking
              directly at a player/mob and within 2-3 blocks of them, this delay
              will occur. It is almost impossible to circumvent this delay no
              matter what you’re doing. It can manifest many times throughout a
              PvP encounter, such as when coming into range of the opponent, or
              if your opponent hits you slightly out of range for a second, or
              if your aim leaves the opponent's hitbox slightly and then
              re-enters.
            </P>
            <P isBlog>
              This is very noticeable in PvP, two or more players are fighting
              and out of nowhere, you stop swinging for a brief moment even
              though you are still clicking. This results in either a missed
              combo or combo being started on you.{" "}
              <A
                href="https://www.youtube.com/watch?v=_AKavMVZxHU"
                target="_blank"
                className="link-color"
              >
                Example of this happening
              </A>
            </P>
            <P isBlog>
              Due to negative misconceptions and backlash, Lunar Client recently
              had to remove this feature which resulted in PvP not only being
              less consistent and smooth, but also not fun to play. The reason
              being for this removal that some players that see this delay fix
              as an “unfair advantage”.
            </P>
            <H2 isBlog>The Solution: HitDelayFixMod</H2>
            <P isBlog>
              We created a forge mod that fixes the issue. We hope that with
              this fix, not only can you guys enjoy smooth combat, but we want
              to get this feature added back to Lunar & Badlion Client. If it is
              available to everyone then it is no longer an unfair advantage. We
              have noticed for a while now how detrimental this bug is when it
              comes to combat & how much nicer it is to have the delay disabled
              entirely.
            </P>
            <H2 isBlog>Technical details</H2>
            <P isBlog>
              As we stated earlier, when you “miss” an attack, your swings are
              blocked for 10 ticks as you can see here
            </P>
            <img
              src={codeExample}
              alt="example of minecraft hit delay code"
              style={{ width: "100%", marginBottom: 20 }}
            />
            <P isBlog>
              If you are swinging while and you "MISS" then it adds the
              leftClickCounter of 10 ticks.
            </P>
            <P isBlog>
              What our forge mod does is change this 10 tick delay to 0 in the
              case of a “MISS”, essentially removing the delay all together and
              make pvp way smoother without a pointless delay.
            </P>
            <img
              src={codeExample2}
              alt="second example of minecraft hit delay code"
              style={{ width: "100%", marginBottom: 20 }}
            />
            <H2 isBlog>Usage guide</H2>
            <P isBlog>
              There are two versions. The first version is the debug mode which
              supports forge 1.8.9, and the second version is the normal version
              which works for all 1.8.x versions of forge.
            </P>
            <H3 isBlog>Normal version</H3>
            <ul className="blog-list">
              <li>Works for all 1.8 versions of forge</li>
              <li>Fix always ON</li>
              <li>will NOT appear in your forge mods list.</li>
            </ul>
            <table
              className="hit-delay-table"
              style={{ width: "100%", marginBottom: 30 }}
            >
              <tr>
                <th colSpan={3}>Commands</th>
              </tr>
              <tr>
                <td colSpan>
                  No commands, plain and simple, the hit delay is always off!
                </td>
              </tr>
            </table>

            <H3 isBlog>Debug version</H3>
            <ul className="blog-list">
              <li>Ability to toggle delay ON or OFF</li>
              <li>Ability to see debug information in chat</li>
              <li>will NOT appear in your forge mods list.</li>
            </ul>
            <table
              className="hit-delay-table"
              style={{ width: "100%", marginBottom: 30 }}
            >
              <tr>
                <th colSpan={2}>Commands</th>
              </tr>
              <tr>
                <td>/hitdelayfix on</td>
                <td>
                  Toggles fix ON which turns off delay and sets it to 0. This is
                  already be enabled by default.
                </td>
              </tr>
              <tr>
                <td>/hitdelayfix off</td>
                <td>
                  Toggles fix OFF which sets the delay back to 10 as default
                  minecraft has it
                </td>
              </tr>
              <tr>
                <td>/hitdelaydebug on</td>
                <td>
                  Toggles debug mode ON which shows you how many hits you’ve
                  made/missed depending on setting
                </td>
              </tr>
              <tr>
                <td>/hitdelaydebug off</td>
                <td>
                  Toggles debug mode OFF which doesn't show anything in chat
                </td>
              </tr>
              <tr>
                <td>/hitdelaydebug reset</td>
                <td>
                  Clears debug number in chat incase you want to count your hits
                  fresh
                </td>
              </tr>
            </table>

            <H2 isBlog>Showcase</H2>

            <P isBlog>Here’s a video that showcases our mod in action</P>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/LBOJURiayO4"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style={{ marginTop: -10, marginBottom: 20, border: "none" }}
            />

            <P isBlog>Here’s a video we’ve made that goes into more detail</P>
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/5p0TyniJitk"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              style={{ marginTop: -10, marginBottom: 20, border: "none" }}
            />

            <H2 isBlog>The Petition</H2>
            <P isBlog>
              The main goal of creating this fix is to try to get Lunar client
              and Badlion client to add this fix, lunar client already had it
              but due to a negative video made about them they were forced to
              remove it because technically it was an unfair advantage. Now that
              a forge mod is available, all we need is for Lunar client and
              badlion client to both agree to add the fix back, I have observed
              over the months since this fix was taken out of lunar client
              constant complaining from the community about the bad hit
              detection in 1.8.
            </P>

            <P isBlog>
              We have created a petition here to give a chance for the community
              to let their feelings about this fix be known, let's send a clear
              message to Badlion and Lunar that we want this fixed!
            </P>
            <Button
              href="https://www.change.org/p/hypixel-servers-should-allow-hitdelayfix-to-improve-1-8-pvp"
              target="_blank"
            >
              Sign the Petition now
            </Button>

            <P isBlog>
              <b>
                We need to come together as a community and agree that this is
                not an intentional part of 1.8 PvP, this is some nasty behavior
                which no one enjoys, we can and should fix this!
              </b>
            </P>
          </Box>
        </Main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.auth.authenticated,
  premium: state.premium,
});

const mapDispatchToProps = {
  ...authActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(HitDelayFixMod);



/** WEBPACK FOOTER **
 ** ./src/views/pages/hitdelayfixmod/index.js
 **/